module.exports = __webpack_public_path__ + "static/media/ic_medal_silver.31bc65d8.png";